export const probabilityList = state => {
  let temps = state.probabilities
  let lists = []

  if (Array.isArray(temps) && temps.length) {
    temps.forEach(temp => {
      lists.push({
        id: temp.id,
        label: temp.name,
        grade: temp.grade
      })
    })
  }

  return lists
}

export const probabilityActivityList = state => {
  let temps = state.probabilityActivities
  let lists = []

  if (Array.isArray(temps) && temps.length) {
    temps.forEach(temp => {
      lists.push({
        id: temp.id,
        label: temp.name,
        probability_name: temp.probability_name,
        probability_grade: temp.probability_grade
      })
    })
  }

  return lists
}

export const listMonth = state => val => {
  let months = [
    'SM',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]

  let month = state.month
  month = []

  for (let index = 0; index < months.length; index++) {
    let dis = false

    if (index < val.emonth && val.eyear == val.ryear) dis = true

    if (index > 0 && index < 10)
      month.push({
        id: '0' + String(index),
        label: months[index],
        isDisabled: dis
      })
    else if (index > 9)
      month.push({
        id: String(index),
        label: months[index],
        isDisabled: dis
      })
  }

  return month
}

export const listYear = state => val => {
  let year = state.year
  year = []

  let y = val

  for (let index = 1; index < 2; index++) {
    year.push({
      id: String(y - index),
      label: String(y - index)
    })
  }

  for (let index = 0; index < 4; index++) {
    year.push({
      id: String(y + index),
      label: String(y + index)
    })
  }

  return year.sort((a, b) => a.id - b.id)
}
